import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import ButtonBase from 'material-ui/ButtonBase'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import Icon from 'material-ui/Icon'
import Tooltip from 'material-ui/Tooltip'
import Typography from 'material-ui/Typography'
import { Link } from 'react-router-dom'
import { withStyles } from 'material-ui/styles'
import styles from '../styles'
import { validateFormData } from '../../../../common/formtool'
import classnames from 'classnames'
import ConfirmDialog from '../../dialog/confirm'
import {
  ModalHeader,
  ModalContents,
  ModalFooter
} from '../../modal'

class ListAttachments extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      error: null,
      removeFileConfirmation: false,
      attachment: null
    }
  }

  componentWillMount() {
    const { jobid, testid, attachments, getAttachments } = this.props
    getAttachments(jobid, testid)
  }

  componentWillUnmount() {
    this.props.clearAttachments()
  }

  handleClose = () => {
    this.props.close()
  }

  showUploadModal = (e) => {
    const { showUplaodModal } = this.props
    showUplaodModal()
  }

  hideUploadModal = (e) => {
    const { hideUplaodModal } = this.props
    hideUplaodModal()
  }

  confirmDeleteAttachment = (e, attachment) => {
    // const { showRemoveFileConfirmModal } = this.props
    // showRemoveFileConfirmModal()
    this.setState({
      removeFileConfirmation: true,
      attachment
    })
  }

  cancelDeleteAttachment = () => {
    this.setState({
      removeFileConfirmation: false,
      attachment: null
    })
  }

  deleteAttachment = () => {
    this.props.deleteAttachment(this.state.attachment)
    this.cancelDeleteAttachment()
  }

  fileDownload = (file) => {
    const { attachmentDownload } = this.props
    attachmentDownload(file)
  }

  render() {
    const {
      classes,
      languages,
      container,
      translate,
      attachments,
      attachmentDownload
    } = this.props

    const {
      errors,
      error
    } = this.state

    const createAttachmentList = () => {
      let list = []
      if (attachments) {
        for (let i = 0; i < 3; i++) {
          if (attachments[i]) {
            list.push(
              <Grid container key={i}>
                {/* <Grid item xs={11}> */}
                <Tooltip title={attachments[i].name} disableTriggerFocus={true}>
                <ButtonBase
                  key={i}
                  className={classes.buttonBase}
                  component={Button}
                  onClick={(e) => this.fileDownload(attachments[i])}
                >
                  <Typography className={classes.handleLongString}>
                    {attachments[i].name}
                  </Typography>
                </ButtonBase>
                </Tooltip>
                {/* </Grid> */}
                {/* <Grid item xs={1}> */}
                <Button
                  className={classes.attchmentRemoveButtons}
                  onClick={(e) => this.confirmDeleteAttachment(e, attachments[i])}
                >
                  <Icon>delete</Icon>
                </Button>

                {/* </Grid> */}
              </Grid>
            )
          } else {
            list.push(
              <Grid container key={i}>
                <Grid item xs={12}>
                  <Button
                    raised
                    className={classes.submit}
                    onClick={(e) => this.showUploadModal(e)}
                  >{translate("settings_upload")}</Button>
                </Grid>
              </Grid>
            )
          }
        }
      } else {
        list = null
      }
      return list
    }

    let confirmDeleteText = translate('attachment_delete_confirm_text', {
      file: this.state.attachment ? this.state.attachment.name : ''
    })

    const $removeFileConfirmation = this.state.removeFileConfirmation ? (
      <ConfirmDialog
        open={this.state.removeFileConfirmation}
        title={translate('attachment_delete_confirm_title')}
        contentText={confirmDeleteText}
        contentSecondaryText={translate('general_confirmation_help_2')}
        okText={translate('general_confirm')}
        cancelText={translate('general_cancel')}
        onOk={this.deleteAttachment}
        onCancel={this.cancelDeleteAttachment}
      />
    ) : (null)
    return (
      <Modal
        open={true}
        onClose={this.handleClose}
      >
        <div className={classes.root}>
          <Paper className={classnames(classes.modal)}>
            <ModalHeader>
              <Grid container alignItems='center' direction='row' justify='flex-start'>
                <Grid item>
                  <Typography type="headline" color="inherit" className={classes.modalHeader}>
                  {translate('job_attachments')}
                  </Typography>
                </Grid>
              </Grid>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
              <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents classes={classes.modal}>
              {createAttachmentList()}
              {$removeFileConfirmation}
            </ModalContents>

<ModalFooter classes={classes}>

</ModalFooter>
          </Paper>
        </div>
      </Modal>
    )
  }
}

export default withStyles(styles)(ListAttachments)



// WEBPACK FOOTER //
// ./src/components/common/jobandtestattachments/list/index.js